module.exports = "<div class=\"inventory-page\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div ui-view=\"tableView\"></div>\n        </div>\n        <div class=\"col-md-6\">\n            <div ui-view=\"detailsView\"></div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/inventory/templates/main.html
// module id = 807
// module chunks = 0